import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'


function lazyLoad(view) {
    return () => import(`@/views/${view}.vue`)
}

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'Home',
        component: lazyLoad('Home'),
    },
        {
            path: '/about',
            name: 'About',
            component: lazyLoad('About')
        },
        {
            path: '/contact',
            name: 'Contact',
            component: lazyLoad('Contact')
        },
        {
            path: '/directions',
            name: 'Directions',
            component: lazyLoad('Directions'),
        },

        {
            path: '/login',
            name: 'login',
            component: lazyLoad('Login'),
        },
        {
            path: '/inventory/:name',
            component: lazyLoad('Inventory/Equipment'),
        },
        {
            path: '/inventory/:name/edit',
            component: lazyLoad('Inventory/EquipmentEdit'),
        },
        {
            name: 'report',
            path: '/admin/report',
            component: lazyLoad('admin/report'),
        },
        {
            name: 'hacks',
            path: '/admin/hacks',
            component: lazyLoad('admin/Hacks'),
        },
        {
            name: 'contacts',
            path: '/admin/contacts',
            component: lazyLoad('admin/Contacts'),
        },
        {
            path: '/admin/equipment-options',
            component: lazyLoad('admin/EquipmentOptions'),
        },
        {
            path: '/admin/equipment-tags',
            component: lazyLoad('admin/EquipmentTags'),
        },
        {
            path: '/admin/equipment-statuses',
            component: lazyLoad('admin/EquipmentStatuses'),
        },
        {
            path: '/admin/equipment-expenses',
            component: lazyLoad('admin/EquipmentExpenses'),
        },
        {
            path: '/admin/equipment-banners',
            component: lazyLoad('admin/EquipmentBanners'),
        },
        {
            path: '/admin/equipment-categories',
            component: lazyLoad('admin/EquipmentCategories'),
        },
        {
            path: '/admin/equipment-received-checklist',
            component: lazyLoad('admin/EquipmentReceivedChecklist'),
        },
        {
            path: '/admin/equipment-sales-ready-checklist',
            component: lazyLoad('admin/EquipmentSalesReadyChecklist'),
        },
        {
            path: '/admin/messages',
            component: lazyLoad('admin/Messages'),
        },
        {
            path: '/admin/uploads',
            component: lazyLoad('admin/Uploads'),
        },
        {
            path: '/admin/users',
            component: lazyLoad('admin/Users'),
        },
        {
            path: '/admin/vin',
            component: lazyLoad('admin/VinTool'),
        }]
})


// Removes error on NavigationDuplicated
function patchRouterMethod (router, methodName)
{
    router['old' + methodName] = router[methodName]
    router[methodName] = async function (location)
    {
        return router['old' + methodName](location).catch((error) =>
        {
            if (error.name === 'NavigationDuplicated')
            {
                return this.currentRoute
            }
            throw error
        })
    }
}

patchRouterMethod(router, 'push')
patchRouterMethod(router, 'replace')

export default router
